<template>
    <v-input :hide-details="hideDetails" :min-width="minWidth" :max-width="maxWidth">
        <div class="d-flex flex-grow-1 nevim" :class="[rowClasses,flexAdditionalClasses]">
            <v-label :for="id" class="font-weight-bold text-wrap" :style="{minWidth: `${minWidth}px`,maxWidth: `${maxWidth}px`}" :class="[labelColor, labelClasses, labelAdditionalClasses]">
                <span>{{ label }}<span v-if="required" class="ml-1 font-weight-bold text-red">*</span></span>
                <slot name="append-label"></slot>
            </v-label>
            <slot v-if="!loading" :id="id"></slot>
            <v-skeleton-loader v-else type="text" style="padding-bottom: 1px" class="border"></v-skeleton-loader>
        </div>
    </v-input>
</template>

<script setup>
import {computed, useId} from "vue";

const props = defineProps({
    label: String,
    id: [String, Number],
    hideDetails: Boolean,
    required: Boolean,
    minWidth: Number,
    maxWidth: Number,
    horizontal: Boolean,
    loading: Boolean,
    labelColor: {
        type: String,
        default: 'text-grey-darken-1',
    },
    rowClasses: [String, Array, Object],
    labelClasses: [String, Array, Object],
})

const uid = useId();
const id = computed(() => props.id || `input-${uid}`);

const labelAdditionalClasses = computed(() => props.horizontal ? 'w-50': 'mb-2')
const flexAdditionalClasses = computed(() => props.horizontal ? 'flex-row': 'flex-column')
</script>

<style scoped lang="scss">
.v-label{
    opacity: 1;
}
</style>
